'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".CpCustomComponent-module_iframe__FEdCg{background-color:transparent;border:0;display:none;margin:0;padding:0;width:100%}";
var styles = {"iframe":"CpCustomComponent-module_iframe__FEdCg"};
styleInject["default"](css_248z, '6903b235-e39b-42e0-bfc9-42819b82f9c5');

exports["default"] = styles;
